import { just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { CurrentUserResource } from '../../../CurrentUser/Types';
import FreebusyStore, { FreebusySettings } from '../../../FreebusyStore';
import FreebusyReactions from '../../../FreebusyStore/FreebusyReactions';
import { TranslationsContext } from '../../../Translations';
import { AvailabilityQuery, AvailabilityRequest, InitSettings } from '../../Freebusy/Types';
import AdDisplayStates from './AdDisplayStates';
import FreebusyCoachingAdStore from './FreebusyCoachingAdStore';
import { FreebusyAdResource } from './Types';

interface Props {
  freebusyCoachingAdResource: FreebusyAdResource;
  freebusyCoachingAdStore: FreebusyCoachingAdStore;
  currentUserResource: CurrentUserResource;
}

class FreebusyCoachingAd extends React.Component<Props, {}> {
  freebusyStore = new FreebusyStore('freebusy-coaching');

  initSettings: InitSettings = {
    buttonType: 'custom',
    buttonId: 'freebusy-coaching-ad-button',
  };

  availabilityRequest: AvailabilityRequest = {
    link: this.props.freebusyCoachingAdResource.payload.link,
    display: 'modal',
    language: this.props.currentUserResource.payload.preferredLanguage.getOrElseValue('en'),
  };

  availabilityQuery: AvailabilityQuery = {
    management: {
      canProposeNewTime: false,
    },
    agenda: this.props.freebusyCoachingAdResource.payload.agenda,
    participants: [
      {
        email: this.props.freebusyCoachingAdResource.payload.proposerParticipant.email,
        name: this.props.freebusyCoachingAdResource.payload.proposerParticipant.name,
        timeZone: this.props.freebusyCoachingAdResource.payload.proposerParticipant.timeZone,
        role: this.props.freebusyCoachingAdResource.payload.proposerParticipant.role,
      },
    ],
  };

  freebusySettings: FreebusySettings = {
    availabilityRequest: this.availabilityRequest,
    availabilityQuery: this.availabilityQuery,
    initSettings: this.initSettings,
  };

  componentDidMount() {
    this.freebusyStore.initializingStore(
      this.freebusySettings,
      this.props.freebusyCoachingAdResource.payload.eventUuid
    );
  }

  render() {
    return (
      <>
        <TranslationsContext.Consumer>
          {(ts) => (
            <FreebusyReactions
              links={just(this.props.freebusyCoachingAdResource.links)}
              store={this.freebusyStore}
              translationsState={ts}
              segmentStore={nothing()}
            />
          )}
        </TranslationsContext.Consumer>
        <AdDisplayStates
          freebusyStore={this.freebusyStore}
          freebusyCoachingAdStore={this.props.freebusyCoachingAdStore}
        />
      </>
    );
  }
}

export default observer(FreebusyCoachingAd);
